import { useState, useEffect } from "react";
import { setSelectedService } from "./components/entityOnboardSlice";
import { useDispatch, useSelector } from "react-redux";

const useEntityOnboarding = (steps = []) => {
  const dispatch = useDispatch();
  const entityservices = useSelector(
    (state) => state.globalEntities.entityservices,
  );
  const selectedservices = useSelector(
    (state) => state.onboarding.selectedservices,
  );

  const allEntities = useSelector((state) => state.globalEntities.entities);
  const allCustomers = useSelector((state) => state.onboarding.organizations);

  const [activeIndex, setActiveIndex] = useState(0);
  const [infoData, setInfoData] = useState();
  const [parentCompanyList, setParentCompanyList] = useState([]);
  const [customersList, setCustomersList] = useState([]);
  const [leave, setLeave] = useState(false);

  useEffect(() => {
    setActiveIndex(0);
    // dispatch(fetchGlobalEntityDetails());
    // dispatch(fetchOrganizations());
    // dispatch(fetchServices());
  }, []);

  const handleBack = () => {
    setActiveIndex((prevActiveStep) => Math.max(prevActiveStep - 1, 0));
  };

  const handleNext = () => {
    setActiveIndex((prevActiveStep) =>
      Math.min(prevActiveStep + 1, steps.length - 1),
    );
  };

  const handleSetCompanyOptions = () => {
    if (allEntities) {
      const companyList = allEntities.map((item) => ({
        name: item.name,
        code: item.id,
      }));

      const filteredArr = Array.from(
        new Set(companyList.map(JSON.stringify)),
      ).map(JSON.parse);
      setParentCompanyList(filteredArr || []);
    }
  };

  const handleSetCustomerOptions = () => {
    if (allCustomers) {
      const companyList = allCustomers.map((item) => ({
        name: item.name,
        code: item.id,
      }));

      const filteredArr = Array.from(
        new Set(companyList.map(JSON.stringify)),
      ).map(JSON.parse);
      setCustomersList(filteredArr || []);
    }
  };

  useEffect(() => {
    handleSetCompanyOptions();
    handleSetCustomerOptions();
  }, [allEntities, allCustomers]);

  const companyType = [
    { name: "Branch", code: "Branch" },
    { name: "Subsidiary", code: "Subsidiary" },
    { name: "Representative Office", code: "Representative Office" },
    { name: "NRE", code: "NRE" },
    { name: "Parent Entity", code: "Parent Entity" },
  ];

  const statusType = [
    { name: "Active", code: "Active" },
    { name: "Action Required", code: "Action Required" },
    { name: "Incomplete", code: "Incomplete" },
    { name: "Non Compliant", code: "Non Compliant" },
    { name: "Dormant", code: "Dormant" },
  ];

  const businessActivity = [
    { name: "Branch", code: "Branch" },
    { name: "Subsidiary", code: "Subsidiary" },
    { name: "Representative Office", code: "Representative Office" },
    { name: "NRE", code: "NRE" },
  ];
  const handleSetService = (data) => {
    dispatch(setSelectedService(data));
  };

  const showDeleteModal = () => {
    setLeave(true);
  };

  return {
    handleBack,
    handleNext,
    activeIndex,
    companyType,
    statusType,
    businessActivity,
    infoData,
    setInfoData,
    entityservices,
    parentCompanyList,
    selectedservices,
    handleSetService,
    showDeleteModal,
    leave,
    setLeave,
    customersList,
  };
};

export default useEntityOnboarding;
